var App = App || {};

App.Base = (function ($) {
    'use strict';

    var $window = $(window),
        $html = $('html'),
        $body = $('body');

    function init() {
        var splide = new Splide('.splide');
        splide.mount();
    }

    
    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Base.init();
});